import _ from "underscore";
import * as aj from "../aj/index";
import { RETAILERS } from "./types";
import * as actions from "../actions/types";
import { completed, failed } from "../utils/ajex";

export function getDefaultState() {
    return {
        retailers: {
            rows: [],
            totalRows: 0,
        },
        currentRetailer: undefined,
    }
}

export const RetailersStore = aj.createStore(RETAILERS, (state = getDefaultState(), action) => {
    switch(action.type) {
        case completed(actions.GET_RETAILERS):
            return _.assign(state, {retailers: action.retailers});
        case completed(actions.GET_RETAILER):
            return _.assign(state, {currentRetailer: action.retailer});
        case actions.CLEAR_RETAILER:
            return _.assign(state, {currentRetailer: undefined})
    }
});